import styled from 'styled-components';

export const Container = styled.div`
  .update-chip {
    white-space: nowrap;
  }

  .update-card {
    border-color: ${(props) => props.theme.$gray300};
    border-left-width: 3px;
    border-left-color: transparent;
  }

  .update-card.is-unread {
    border-left-color: ${(props) => props.theme.$danger};
  }

  .update-card.is-read {
    background: ${(props) => props.theme.$gray100};
  }

  .update-icon {
    width: 40px;
    height: 40px;
    background: ${(props) => props.theme.$gray200};
  }

  .update-icon .material-icons {
    font-size: 20px;
    color: ${(props) => props.theme.$gray600};
  }

  .update-card.is-unread .update-icon {
    background: ${(props) => props.theme.$danger_light_bg};
  }

  .update-card.is-unread .update-icon .material-icons {
    color: ${(props) => props.theme.$danger};
  }

  .update-card.is-read .update-icon .material-icons {
    color: ${(props) => props.theme.$gray500};
  }

  .update-title {
    color: ${(props) => props.theme.$dark};
  }

  .update-card.is-read .update-title {
    color: ${(props) => props.theme.$gray700};
  }

  .update-meta,
  .update-date {
    font-size: 13px;
  }

  .update-body {
    font-size: 14px;
    color: ${(props) => props.theme.$gray700};
  }

  .min-width-0 {
    min-width: 0;
  }
`;
